module.exports = __webpack_public_path__ + "img/imageAdd2.bf129fd2.webp";